// extracted by mini-css-extract-plugin
export default {"tooltip__line":"TooltipIconComment_tooltip__line__2uFNE"};